import { AsyncPipe, DatePipe, CommonModule, TitleCasePipe } from '@angular/common';
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  OnDestroy,
  Renderer2,
  DOCUMENT
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WelcomeModalComponent } from './welcome-modal/welcome-modal.component';
import { Router, RouterLink } from '@angular/router';
import { ConfigService } from '@config';
import { InConfiguration, AuthService } from '@core';
import { ThemeService } from '@core/service/theme.service';
import { FeatherIconsComponent } from '@shared/components/feather-icons/feather-icons.component';
import { NgScrollbar } from 'ngx-scrollbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { NotificationService, AppNotification } from '@core/service/notification.service';
import { Observable } from 'rxjs';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [
        RouterLink,
        AsyncPipe,
        DatePipe,
        TitleCasePipe,
        CommonModule,
        MatButtonModule,
        MatMenuModule,
        NgScrollbar,
        FeatherIconsComponent,
    ],
})
export class HeaderComponent implements OnInit, OnDestroy {
  public config!: InConfiguration;
  isSidebarCollapsed = false;
  user: any = {};
  selectedHotel: any;
  notifications$!: Observable<AppNotification[]>;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private authService: AuthService,
    private router: Router,
    private themeService: ThemeService,
    private configService: ConfigService,
    public notificationService: NotificationService,
    private modalService: NgbModal,
  ) {
    this.user = this.authService.getCurrentUser();
  }

  ngOnInit() {
    this.config = this.configService.configData;
    this.isSidebarCollapsed = localStorage.getItem('collapsed_menu') === 'true';
    this.notifications$ = this.notificationService.notifications;
    this.notificationService.init();
    this.showWelcomeIfFirstLogin();
  }

  private showWelcomeIfFirstLogin(): void {
    const isFirst = this.user?.is_first_login;
    if (!isFirst || localStorage.getItem('hgx_guide_seen')) return;

    const modalRef = this.modalService.open(WelcomeModalComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false,
      windowClass: 'welcome-modal-window',
    });
    modalRef.componentInstance.userName =
      this.user?.prenom || this.user?.nom || 'cher utilisateur';
  }

  ngOnDestroy() {
    this.notificationService.ngOnDestroy();
  }

  get isDark(): boolean {
    return this.themeService.theme === 'dark';
  }

  get initiales(): string {
    return [this.user?.prenom, this.user?.nom]
      .filter(Boolean)
      .map((part: string) => part.trim().charAt(0).toUpperCase())
      .join('');
  }

  toggleTheme() {
    this.themeService.setTheme(this.isDark ? 'light' : 'dark');
  }

  get unreadCount(): number {
    return this.notificationService.unreadCount;
  }
  mobileMenuSidebarOpen(event: Event, className: string) {
    const hasClass = (event.target as HTMLInputElement).classList.contains(
      className
    );
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }
  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains('side-closed');
    if (hasClass) {
      this.renderer.removeClass(this.document.body, 'side-closed');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
      localStorage.setItem('collapsed_menu', 'false');
      this.isSidebarCollapsed = false;
    } else {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
      localStorage.setItem('collapsed_menu', 'true');
      this.isSidebarCollapsed = true;
    }
  }
  logout() {
    this.authService.logout().subscribe((res) => {
      if (!res.success) {
        this.router.navigate(['/authentication/signin']);
      }
    });
  }
}
